<script lang="ts">
	import '$lib/style/reset.css';
	import '$lib/style/main.css';
	import { Bluetooth } from '$lib/bluetooth.svelte';

	let name = $state('');
	let pass = $state('');

	const writeConfig = async () => {
		await Bluetooth.write(`${name}:${pass}`);
	}

	const readConfig = async () => {
		const config = await Bluetooth.read();
		const spl = config.split(/\:/g);
		if(!spl || spl.length < 2) {
			throw new Error('Failed to format connection config');
		}
		name = spl[0];
		pass = spl[1];
	}
</script>

<h1>Thea's ramme</h1>
<p class="connection">Status: {Bluetooth.pairing ? 'forbinder...' : Bluetooth.connected ? 'forbundet!' : 'ikke forbundet.'}</p>
<button onclick={Bluetooth.connect} disabled={Bluetooth.pairing}>Forbind</button>
<form onsubmit={writeConfig} class:disabled={!Bluetooth.ready}>
	<h2>Wi-fi login</h2>
	<button onclick={readConfig} disabled={!Bluetooth.ready}>{Bluetooth.reading ? 'Henter fra ramme...' : 'Hent wi-fi oplysninger'}</button>
	<label>
		<p>Navn</p>
		<input type="text" disabled={!Bluetooth.ready} bind:value={name} />
	</label>
	<label>
		<p>Kodeord</p>
		<input type="password" disabled={!Bluetooth.ready} bind:value={pass} />
	</label>
	<button type="submit" onclick={writeConfig} disabled={!Bluetooth.ready}>{Bluetooth.writing ? 'Skriver til ramme...' : 'Sæt wi-fi oplysninger'}</button>
</form>

<style>
	form {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: start;
		gap: 1rem;
		padding-block: 2rem;
		padding-inline: 3rem;
		border-radius: .5rem;
		border-width: 2px;
		border-style: solid;
		border-color: env(--main-border);

		&.disabled label {
			opacity: .5;
		}
	}

	label {
		width: 100%;
		display: flex;
		justify-content: space-between;
		gap: 1rem;
	}

	input {
		width: 10rem;
	}
</style>